import FacebookIcon from '@mui/icons-material/Facebook';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import SnapChatIcon from '../../../shared/icons/SnapChatIcon';
import type { IPlatformChoice } from '../../store/reducers/selected-platforms.slice';
import BidTheatreIcon from '../../../shared/icons/bidtheatreIcon';
import BoardsIcon from '@/shared/icons/boardsIcon';
import GoogleIcon from '@mui/icons-material/Google';

export enum AvailablePlatformsEnum {
  META = 'meta',
  SNAPCHAT = 'snapchat',
  DELTA = 'delta',
  BIDTHEATRE = 'bidtheatre',
  BOARDS = 'boards',
  FINN = 'finn',
  OGDISPLAY = 'ogdisplay',
  GOOGLE_ADS = 'google',
}

// export type PlatformType = 'meta' | 'snapchat' | 'delta' | 'bidtheatre' | 'boards' | 'google';
export type PlatformType = Exclude<`${AvailablePlatformsEnum}`, 'finn' | 'ogdisplay'>;

export const PLATFORM_KEYS: PlatformType[] = ['meta', 'delta', 'snapchat', 'bidtheatre', 'boards', 'google'];

export const availablePlatforms: IPlatformChoice[] = [
  {
    id: 'meta',
    title: 'Meta',
    icon: FacebookIcon,
  },
  {
    id: 'snapchat',
    title: 'Snapchat',
    icon: SnapChatIcon,
  },
  {
    id: 'delta',
    title: 'OG Display',
    icon: NewspaperIcon,
  },
  {
    id: 'google',
    title: 'Google',
    icon: GoogleIcon,
  },
  {
    id: 'bidtheatre',
    title: 'bidtheatre',
    icon: BidTheatreIcon,
  },
  {
    id: 'boards',
    title: 'boards',
    icon: BoardsIcon,
  },
];

export const PLATFORM_ICON_MAP = new Map(availablePlatforms.map((p) => [p.id, p.icon]));

export const platformsToCropImage = [{ platform: AvailablePlatformsEnum.SNAPCHAT, width: 1080, height: 1920 }];

// export default availablePlatforms;
